import service from '../allservices.jsx'
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js';
export function countryService(actionCallback) {

    let path = service.country 
    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    let traceId = getClientId();
    let gid = getClientId()
    // fetch(path)
    fetch(plink + path, {
        headers: {
            'X-Trace-Id': traceId,
            'clientId': gid,
            'clientSecret': getClientSecret(gid, ""),
            'X-Client-APP':buildClientHeader(),
        }
    })
        .then(response => {
            if (response.status === 200) {
                return response.json()
            } else {
               
            }

        })
        .then(json => actionCallback(json))
}


// WEBPACK FOOTER //
// ./src/services/components/country_service.jsx